import { type FC } from "react";
import * as styles from "@root/shared/components/DefinitionList/styles.css";

export type DefinitionListItemProps = {
  /** コンポーネントに適用するクラス名 */
  className?: string;
  /** definition term(dt)の内容 */
  term: React.ReactNode;
  /** definition description(dd)の内容) */
  description: React.ReactNode;
};

export const Item: FC<DefinitionListItemProps> = ({ term, description, className }) => (
  <dl
    className={`
      ${styles.dl}
      ${className || ""}
    `}
  >
    <dt className={styles.dt}>{term}</dt>
    <dd className={styles.dd}>{description}</dd>
  </dl>
);
